import { Box, Typography } from '@mui/material';
import { resolveMuiIconByName } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LOOP_COLOR_LIST = [{
  iconBgColor: '#F8EBFB',
  textColor: '#BB33D5'
}, {
  iconBgColor: '#E4FCED',
  textColor: '#1CB258'
}, {
  iconBgColor: '#EBEFFE',
  textColor: '#0E35D1'
}, {
  iconBgColor: '#F7DAE2',
  textColor: '#CD0F47'
}];

var IntroAdvantageCard = function IntroAdvantageCard(props) {
  var item = props.item,
      index = props.index;
  var AdvantageIcon = resolveMuiIconByName(item.iconName);
  var _LOOP_COLOR_LIST = LOOP_COLOR_LIST[index % LOOP_COLOR_LIST.length],
      iconBgColor = _LOOP_COLOR_LIST.iconBgColor,
      textColor = _LOOP_COLOR_LIST.textColor;
  /**
   * methods
   */

  var renderIcon = function renderIcon() {
    if (!AdvantageIcon) return null;
    return /*#__PURE__*/_jsx(Box, {
      className: "flex h-14 w-14 items-center justify-center rounded-xl",
      style: {
        backgroundColor: iconBgColor
      },
      children: /*#__PURE__*/_jsx(AdvantageIcon, {
        className: "h-8 w-8",
        htmlColor: textColor
      })
    });
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex h-full flex-col space-y-4 rounded-2xl bg-white p-8 shadow-[0_16px_48px_-32px_rgba(0,109,176,0.25)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-32px_rgba(0,109,176,0.4)]",
    children: [renderIcon(), /*#__PURE__*/_jsx(Typography, {
      className: "font-['Playfair_Display',serif] text-2xl font-black leading-snug text-[#202020] md:text-[26px]",
      children: item.title
    }), /*#__PURE__*/_jsx(Typography, {
      className: "text-sm font-medium leading-6 text-[#202020] md:text-lg",
      children: item.desc
    })]
  });
};

export default IntroAdvantageCard;